import { render, staticRenderFns } from "./SafetyDataSheetManage.vue?vue&type=template&id=71aee0aa&"
import script from "./SafetyDataSheetManage.vue?vue&type=script&lang=js&"
export * from "./SafetyDataSheetManage.vue?vue&type=script&lang=js&"
import style0 from "./SafetyDataSheetManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports